export const moduleConfig = {
    entityKey: 'usage-events',
    titles: {
        singular: 'Usage Event',
        plural: 'Usage Events'
    }
}

export const initialSortState = {
    column: 'created',
    direction: 'desc',
};
